import React, { Component } from "react";
import Slider from "react-slick";

export default class PreviousNextMethods extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }
    render() {
        const settings = {
            className: "center",
            centerMode: true,
            infinite: true,
            arrows: false,
            dots: false,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            // autoplay: true,
            // autoplaySpeed: 2000,


            
            
        };
        return (
            <div>

                <Slider ref={c => (this.slider = c)} {...settings}>

                    <div class="container" >
                        <div class="row align-items-center">
                            <div class="col-5">
                                <img width="250px" height="400px" className="Rectangle94" alt="Vector" src="./Teraone/Rectangle 94 (1).png" />

                            </div>
                            <div class="col-6" >
                                <button className="greatButton" >Great</button>
                                <div className="persondetails" >Lorem ipsum dolor sit amet consectetur. Venenatis at nibh et sit. </div>
                                <div className="persondetailspara" >Lorem ipsum dolor sit amet consectetur. Tristique tellus odio ullamcorper semper sed aliquam. Et lacus bibendum vitae gravida. Mi lorem condimentum tempus semper faucibus sit elit. Orci consectetur ultricies faucibus ipsum viverra amet. Amet pharetra est sit vestibulum.</div>
                                <img width="50px" height="50px" className="persondetailsEllipse7" alt="Vector" src="./Teraone/Ellipse 7 (1).png" />
                                <h6 className="personComment">Luca Micheli,CEO Customerlya</h6>
                                <p className="personCommentPara">Communication Suite</p>

                            </div>

                        </div>
                    </div>


                    <div class="container" >
                        <div class="row align-items-center">
                            <div class="col-5">
                                <img width="250px" height="400px" className="Rectangle94" alt="Vector" src="./Teraone/Rectangle 94 (1).png" />

                            </div>
                            <div class="col-6" >
                                <button className="greatButton" >Great</button>
                                <div className="persondetails" >Lorem ipsum dolor sit amet consectetur. Venenatis at nibh et sit. </div>
                                <div className="persondetailspara" >Lorem ipsum dolor sit amet consectetur. Tristique tellus odio ullamcorper semper sed aliquam. Et lacus bibendum vitae gravida. Mi lorem condimentum tempus semper faucibus sit elit. Orci consectetur ultricies faucibus ipsum viverra amet. Amet pharetra est sit vestibulum.</div>
                                <img width="50px" height="50px" className="persondetailsEllipse7" alt="Vector" src="./Teraone/Ellipse 7 (1).png" />
                                <h6 className="personComment">Luca Micheli,CEO Customerlya</h6>
                                <p className="personCommentPara">Communication Suite</p>

                            </div>

                        </div>
                    </div>
                    <div class="container" >
                        <div class="row align-items-center">
                            <div class="col-5">
                                <img width="250px" height="400px" className="Rectangle94" alt="Vector" src="./Teraone/Rectangle 94 (1).png" />

                            </div>
                            <div class="col-6" >
                                <button className="greatButton" >Great</button>
                                <div className="persondetails" >Lorem ipsum dolor sit amet consectetur. Venenatis at nibh et sit. </div>
                                <div className="persondetailspara" >Lorem ipsum dolor sit amet consectetur. Tristique tellus odio ullamcorper semper sed aliquam. Et lacus bibendum vitae gravida. Mi lorem condimentum tempus semper faucibus sit elit. Orci consectetur ultricies faucibus ipsum viverra amet. Amet pharetra est sit vestibulum.</div>
                                <img width="50px" height="50px" className="persondetailsEllipse7" alt="Vector" src="./Teraone/Ellipse 7 (1).png" />
                                <h6 className="personComment">Luca Micheli,CEO Customerlya</h6>
                                <p className="personCommentPara">Communication Suite</p>

                            </div>

                        </div>
                    </div>

                    <div class="container" >
                        <div class="row align-items-center">
                            <div class="col-5">
                                <img width="250px" height="400px" className="Rectangle94" alt="Vector" src="./Teraone/Rectangle 94 (1).png" />

                            </div>
                            <div class="col-6" >
                                <button className="greatButton" >Great</button>
                                <div className="persondetails" >Lorem ipsum dolor sit amet consectetur. Venenatis at nibh et sit. </div>
                                <div className="persondetailspara" >Lorem ipsum dolor sit amet consectetur. Tristique tellus odio ullamcorper semper sed aliquam. Et lacus bibendum vitae gravida. Mi lorem condimentum tempus semper faucibus sit elit. Orci consectetur ultricies faucibus ipsum viverra amet. Amet pharetra est sit vestibulum.</div>
                                <img width="50px" height="50px" className="persondetailsEllipse7" alt="Vector" src="./Teraone/Ellipse 7 (1).png" />
                                <h6 className="personComment">Luca Micheli,CEO Customerlya</h6>
                                <p className="personCommentPara">Communication Suite</p>

                            </div>

                        </div>
                    </div>
                    <div class="container" >
                        <div class="row align-items-center">
                            <div class="col-5">
                                <img width="250px" height="400px" className="Rectangle94" alt="Vector" src="./Teraone/Rectangle 94 (1).png" />

                            </div>
                            <div class="col-6" >
                                <button className="greatButton" >Great</button>
                                <div className="persondetails" >Lorem ipsum dolor sit amet consectetur. Venenatis at nibh et sit. </div>
                                <div className="persondetailspara" >Lorem ipsum dolor sit amet consectetur. Tristique tellus odio ullamcorper semper sed aliquam. Et lacus bibendum vitae gravida. Mi lorem condimentum tempus semper faucibus sit elit. Orci consectetur ultricies faucibus ipsum viverra amet. Amet pharetra est sit vestibulum.</div>
                                <img width="50px" height="50px" className="persondetailsEllipse7" alt="Vector" src="./Teraone/Ellipse 7 (1).png" />
                                <h6 className="personComment">Luca Micheli,CEO Customerlya</h6>
                                <p className="personCommentPara">Communication Suite</p>

                            </div>

                        </div>
                    </div>
                </Slider>
                <div style={{ textAlign: "center" }}>
                    <button className="personDetailsbuttonPrev" onClick={this.previous}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Frame" clip-path="url(#clip0_188_438)">
                                <path id="Vector" d="M7.828 11L13.192 5.63605L11.778 4.22205L4 12L11.778 19.778L13.192 18.364L7.828 13H20V11H7.828Z" fill="black" />
                            </g>
                            <defs>
                                <clipPath id="clip0_188_438">
                                    <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                                </clipPath>
                            </defs>
                        </svg>

                    </button>
                    <button className="personDetailsbuttonNext" onClick={this.next}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Frame" clip-path="url(#clip0_188_433)">
                                <path id="Vector" d="M16.172 11L10.808 5.63605L12.222 4.22205L20 12L12.222 19.778L10.808 18.364L16.172 13H4V11H16.172Z" fill="black" />
                            </g>
                            <defs>
                                <clipPath id="clip0_188_433">
                                    <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </button>
                </div>
            </div>
        );
    }
}